<template>
  <div id="sideBar"
       class="sideBarContainer h-100">
    <div class="d-flex flex-column align-items-center mt-3 pt-3">
      <button id="sideBarBtn"
              v-b-tooltip.hover.left="'Atualizações do sistema'"
              v-ripple
              class="border-0 p-0 mb-3"
              type="button"
              @click="openSidebar('clickedOnReleases')">
        <div class="qtdReleasesContainer">
          <span class="qtdReleases">
            {{ qtdUnreadEntriesReleases > 99 ? '99+' : qtdUnreadEntriesReleases }}
          </span>
          <svg class="icon--md background"
               role="presentation">
            <use :xlink:href="'#' + systemUpdateIcon.id" />
          </svg>
        </div>
      </button>

      <ConexaoComWs />

      <button id="sideBarBtn_certidoesPendentesCRC"
              v-b-tooltip.hover.left="'Certidões Pendentes da CRC'"
              v-ripple
              class="border-0 p-0 my-3"
              type="button"
              @click="openSidebar('clickedOnCertidoesPendentesCRC')">
        <div class="qtdCertidoesPendentesCrcContainer">
          <span class="qtdCertidoesPendentesCrc">
            {{ pedidosPendentesBase.length > 99 ? '99+' : pedidosPendentesBase.length }}
          </span>
          <svg class="icon-size--26 background"
               role="presentation">
            <use :xlink:href="'#' + certidoesPendentesCrc.id" />
          </svg>
        </div>
      </button>

      <button id="sideBarBtn_certidoesPendentesP13"
              v-b-tooltip.hover.left="'Pedidos Provimento 13'"
              v-ripple
              class="border-0 p-0 my-2"
              type="button"
              @click="openSidebar('clickedOnPedidosPendentesP13')">
        <div class="qtdCertidoesPendentesCrcContainer">
          <span class="qtdCertidoesPendentesCrc">
            {{ !pedidosPendentesP13 ? '' : pedidosPendentesP13.length > 99 ? '99+' : pedidosPendentesP13.length }}
          </span>
          <svg class="icon-size--26 background"
               role="presentation">
            <use :xlink:href="'#' + pedidosProvimento13.id" />
          </svg>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
  /* Ícones */
  import systemUpdateIcon from '@/assets/icons/system-update.svg?sprite'
  import certidoesPendentesCrc from '@/assets/icons/certidoes-pendentes-crc.svg?sprite'
  import pedidosProvimento13 from '@/assets/icons/pedidos-provimento-13.svg?sprite'
  
  import ConexaoComWs from "@/components/SofiaRei/ConexaoComWSGerenciadorDeTarefas/ConexaoComWs"
  import { mapGetters } from "vuex"

  /* utils */
  import { saveReleaseNotesData } from '@/utils/releasesNotes'


  /* services */
  import CertidoesCRCService from '../services/CertidoesCRCService'
  import ProvimentoTrezeService from '../services/ProvimentoTrezeService'

  export default {
    name: 'SideBarReleasesNotes',
    components: {
      ConexaoComWs
    },
    data () {
      return {
        systemUpdateIcon,
        certidoesPendentesCrc,
        pedidosProvimento13
      }
    },
    computed: {
      ...mapGetters({
        qtdUnreadEntriesReleases: 'releasesNotes/getNumberUnreadReleases',
        pedidosPendentesBase: 'releasesNotes/getPedidosPendentesBase',
        pedidosPendentesP13: 'releasesNotes/getPedidosPendentesP13'
      })
    },
    created(){
      this.getPedidosPendentesCRC()
      this.getPedidosPendentesP13()
    },
    mounted () {
      this.init ()
    },
    methods: {
      init () {
        saveReleaseNotesData()
      },
      async getPedidosPendentesCRC () {
        await CertidoesCRCService.obterPedidosPendentes()
      },  
      async getPedidosPendentesP13 () {
        await ProvimentoTrezeService.obterPedidosPendentes()
      },
      async openSidebar (sidebarButtonClicked) {

        if (sidebarButtonClicked == 'clickedOnReleases') {
          const showSideBar = document.querySelectorAll('.showSideBarReleasesNotes')[0]


          if (showSideBar) {
            showSideBar.style.marginRight = 0
            showSideBar.style.transition = `all ease ${1.2}s`
          }

          this.$store
            .dispatch('releasesNotes/setSaveIsOpenSideBarReleasesNotesData', { data: true, clickedOn: sidebarButtonClicked})
            .then(res => res)
            .catch(err => { throw err })

        }

        else if (sidebarButtonClicked == 'clickedOnPedidosPendentesP13') {
          await this.getPedidosPendentesP13()
          const showSideBar = document.querySelectorAll('.showSideBarReleasesNotes')[0]

          if (showSideBar) {
            showSideBar.style.marginRight = 0
            showSideBar.style.transition = `all ease ${1.2}s`
          }

          this.$store
            .dispatch('releasesNotes/setSaveIsOpenSideBarReleasesNotesData', { data: true, clickedOn: sidebarButtonClicked})
            .then(res => res)
            .catch(err => { throw err })
        }         
        
        else if (sidebarButtonClicked == 'clickedOnCertidoesPendentesCRC') {
          await this.getPedidosPendentesCRC()
          const showSideBar = document.querySelectorAll('.showSideBarReleasesNotes')[0]


          if (showSideBar) {
            showSideBar.style.marginRight = 0
            showSideBar.style.transition = `all ease ${1.2}s`
          }

          this.$store
            .dispatch('releasesNotes/setSaveIsOpenSideBarReleasesNotesData', { data: true, clickedOn: sidebarButtonClicked})
            .then(res => res)
            .catch(err => { throw err })
        }      

      }
    }
  }
</script>

<style lang="scss" scoped>
 @import '@/scss/_utilities/_exports';
  .sideBarContainer {
    position: fixed;
    right: 0;
    top: 0;
    width: 3%;
    background-color: #F9F9F9;
    padding-top: 8vh;
    z-index: 1;
  }

  .qtdReleasesContainer, .qtdCertidoesPendentesCrcContainer {
    position: relative;
    
    .background {
      background-color: #F9F9F9;
    }
  }

  .qtdBase {
    position: absolute;
    top: -1vh;
    right: 0;
    background: #8b0000;
    color: white;
    width: 1.1rem;
    height: 1.1rem;
    font-weight: 500;
    font-size: 0.7rem;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qtdReleases {
    @extend .qtdBase;
  }

  .qtdCertidoesPendentesCrc {
    @extend .qtdBase;
    right: -5px;
  }

  .icon-size--26 {
    height: pxToRem(26);
    width: pxToRem(26);
  }
</style>
